import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import { withTranslation } from 'react-i18next'
import MobileWrapper from '../../components/MobileWrapper'
import MobileHeader from '../../components/MobileHeader'
import MobileContent from '../../components/MobileContent'
import WhiteBox from '../../components/WhiteBox'
import balanceIcon from '../../assets/images/payment/balance.png'
import { moneyFormatter } from '../../utils/formatter'
import { getUser } from '../../reducers/user'
import StyleButton from '../../components/StyleButton'
import TextInput from '../../components/TextInput'
import ImageDropzone from '../../components/ImageDropzone'

const styles = () => {
  return {
    uploadContainer: {
      marginTop: '10px',
      marginLeft: '10px',
      marginRight: '10px',
      minHeight: '80px',
      height: '25vh',
    },
    label: {
      color: 'grey',
      fontSize: '12px',
    },
    confirmButtonContainer: {
      marginTop: '50px',
    },
  }
}

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

@withRouter
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@withTranslation()
@injectSheet(styles)
class BankTransferPage extends Component {
  state = {
    defaultPrecision: 2,
    bankSlipImage: null,
    amount: '',
  }

  handleImageDropzoneOnDrop = (image) => {
    if (!image || !image.length) {
      return
    }
    this.setState({
      bankSlipImage: image[0],
    })
  }

  handleSubmitButtonClick = () => {
    const { amount, bankSlipImage } = this.state
    const formData = new FormData()
    formData.set('image', bankSlipImage)
    formData.set('amount', amount)
    console.log(formData)
    console.log('handleSubmit')
  }

  handleAmountChange = (amount) => {
    let { defaultPrecision } = this.state
    defaultPrecision = Number(defaultPrecision)

    if (/^0*$/.test(amount)) {
      this.setState({
        amount: '0',
      })
    } else {
      let updatedAmount = amount.replace(/^0+/, '')
      if (updatedAmount[0] === '.') {
        updatedAmount = `0${updatedAmount}`
      }

      if (updatedAmount.indexOf('.') > -1) {
        const separatedAmount = updatedAmount.split('.')
        const precision = separatedAmount[1].length

        if (precision < defaultPrecision) {
          this.setState({
            amount: updatedAmount,
          })
        } else {
          this.setState({
            amount: `${separatedAmount[0]}.${separatedAmount[1].slice(0, defaultPrecision)}`,
          })
        }
      } else {
        this.setState({
          amount: updatedAmount,
        })
      }
    }
  }

  render() {
    const { classes, user, t } = this.props
    const { amount } = this.state
    return (
      <MobileWrapper overlay={true}>
        <MobileHeader title={t('bank_transfer')} />
        <MobileContent>
          <WhiteBox
            title={`${t('spc_wallet')}$${moneyFormatter(user.wallet_balance)}`}
            description={t('my_balance')}
            image={balanceIcon}
          />
          <div>
            <TextInput
              placeholder={t('amount')}
              type={'number'}
              onChange={this.handleAmountChange}
              value={amount}
            />
          </div>
          <div className={classes.uploadContainer}>
            <label className={classes.label}>
              {t('bank_slip')}
              <ImageDropzone onDrop={this.handleImageDropzoneOnDrop} />
            </label>
          </div>
          <div className={classes.confirmButtonContainer}>
            <StyleButton name={t('confirm')} onClick={this.handleSubmitButtonClick} />
          </div>
        </MobileContent>
      </MobileWrapper>
    )
  }
}

BankTransferPage.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired,
  }),
  classes: PropTypes.object,
  user: PropTypes.object,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  t: PropTypes.func,
}

export default BankTransferPage
